"use client"

import { useChains } from "@opensea/app-kit"
import { useChainArch } from "./useChainArch"
import { useChainId } from "./useChainId"

export function useChainIdentifier() {
  const chainId = useChainId()
  const chainArch = useChainArch()
  const { getChainIdentifier } = useChains()
  return chainId ? getChainIdentifier(chainId, chainArch) : undefined
}
